<h2 mat-dialog-title>{{ titleKey() | translate }}</h2>

<mat-dialog-content>
    <p class="av-billing-note mb-3">{{ componentLabelKey() | translate }}</p>

    @if (isCancelMode() && maxQuantity() === 0) {
    <p class="av-billing-warning mb-0">{{ 'app.billing.licences.cancel.none' | translate }}</p>
    } @else {
    <mat-form-field appearance="outline" class="w-100">
        <mat-label>{{ 'app.billing.licences.quantity' | translate }}</mat-label>
        <input matInput type="number" [min]="minQuantity" [max]="maxQuantity()" [value]="quantity()"
            (input)="setQuantity($any($event.target).value)" />
        @if (isCancelMode()) {
        <mat-hint>{{ 'app.billing.licences.cancel.max' | translate: maxParams() }}</mat-hint>
        } @else if (data.component.unit_amount !== null) {
        <mat-hint>
            {{ 'app.billing.licences.unit_price' | translate: {
                    amount: (data.component.unit_amount | currency: (data.component.currency ?? 'EUR') : 'symbol' : '1.2-2')
                } }}
        </mat-hint>
        }
    </mat-form-field>

    <p class="av-billing-note mt-3 mb-0">
        {{ (isCancelMode() ? 'app.billing.licences.cancel.hint' : 'app.billing.licences.buy.hint') | translate }}
    </p>
    }
</mat-dialog-content>

<mat-dialog-actions align="end">
    <button mat-stroked-button (click)="close()">{{ 'shared.general.buttons.cancel' | translate }}</button>
    <button mat-flat-button color="primary" [disabled]="isConfirmDisabled()" (click)="confirm()">
        {{ confirmKey() | translate }}
    </button>
</mat-dialog-actions>
